var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import responseToJson from "../util/responseToJson";
import { getCookieCustomerNumber, getCookiePunchoutSessionEpochStart } from "../util/cookies";
var submitGenericAnalyticEvent = function (analyticEvent, isEventTaxonomyV2) { return __awaiter(void 0, void 0, void 0, function () {
    var queryParams, baseHeaders;
    return __generator(this, function (_a) {
        queryParams = "customerNumber=".concat(encodeURIComponent(getCookieCustomerNumber()));
        setPunchoutFlagIfPresent(analyticEvent);
        baseHeaders = { "Content-Type": "application/json" };
        return [2 /*return*/, fetch("/max/web-analytics/events?".concat(queryParams), {
                method: "POST",
                headers: isEventTaxonomyV2 ? __assign(__assign({}, baseHeaders), { "Event-Taxonomy": "V2" }) : baseHeaders,
                credentials: "include",
                keepalive: true,
                body: JSON.stringify(analyticEvent)
            }).then(responseToJson)];
    });
}); };
var Integration = {
    submitAnalyticEvent: function (analyticEvent) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                submitGenericAnalyticEvent(analyticEvent, false);
                return [2 /*return*/];
            });
        });
    },
    submitAnalyticEventV2: function (analyticEvent) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                submitGenericAnalyticEvent(analyticEvent, true);
                return [2 /*return*/];
            });
        });
    },
    submitAnalyticPublicEvent: function (analyticEvent) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl, queryParams, body;
            return __generator(this, function (_c) {
                baseUrl = (_a = window.analyticsBaseUrl) !== null && _a !== void 0 ? _a : "";
                queryParams = "userEmail=".concat(encodeURIComponent((_b = analyticEvent.userEmail) !== null && _b !== void 0 ? _b : ""));
                setPunchoutFlagIfPresent(analyticEvent);
                body = "eventName=".concat(analyticEvent.eventName, "&page=").concat(analyticEvent.page);
                body += analyticEvent.eventData ? "&eventData=".concat(encodeURIComponent(JSON.stringify(analyticEvent.eventData))) : "";
                return [2 /*return*/, fetch("".concat(baseUrl, "/max/web-analytics/public/events?").concat(queryParams), {
                        method: "POST",
                        headers: { "Content-Type": "application/x-www-form-urlencoded", "Event-Taxonomy": "V1" },
                        credentials: "include",
                        keepalive: true,
                        body: body
                    }).then(responseToJson)];
            });
        });
    },
    getAnalyticsConfiguration: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, fetch("/max/web-analytics/public/configuration", {
                        method: "GET"
                    }).then(responseToJson)];
            });
        });
    }
};
function setPunchoutFlagIfPresent(analyticEvent) {
    if (getCookiePunchoutSessionEpochStart()) {
        analyticEvent.eventData = __assign(__assign({}, analyticEvent.eventData), { isPunchout: true });
    }
}
export default Integration;
